(function () {
  // let testimonialsSlide = () => {
  //     var $slickElement = $(".maker-spotlight__slider").not(
  //         ".slick-initialized"
  //     );

  //     $slickElement.on(
  //         "init reInit afterChange",
  //         function (event, slick, currentSlide, nextSlide) {
  //             var i = (currentSlide ? currentSlide : 0) + 1;
  //             $(this)
  //                 .parent()
  //                 .find(".testimonials__counts")
  //                 .text(i + "/" + slick.slideCount);
  //         }
  //     );

  //     $slickElement.slick({
  //         slidesToShow: 4,
  //         arrows: false,
  //         dots: false,
  //         adaptiveHeight: true,
  //         responsive: [
  //             {
  //                 breakpoint: 960,
  //                 settings: {
  //                     slidesToShow: 2,
  //                 },
  //             },
  //             {
  //                 breakpoint: 768,
  //                 settings: {
  //                     slidesToShow: 1,
  //                 },
  //             },
  //         ],
  //     });

  //     $(".testimonials__button--next").click(function () {
  //         $(this)
  //             .parents(".maker-spotlight")
  //             .find(".maker-spotlight__slider")
  //             .slick("slickNext");
  //     });
  //     $(".testimonials__button--prev").click(function () {
  //         $(this)
  //             .parents(".maker-spotlight")
  //             .find(".maker-spotlight__slider")
  //             .slick("slickPrev");
  //     });
  // };

  // document.addEventListener("shopify:section:load", function () {
  //     testimonialsSlide();
  // });

  // testimonialsSlide();

  const pseudoNextButton = document.querySelector();
  const pseudoPrevButton = document.querySelector();

  const instafeedNextButton = document.querySelector();
  const instfeedPrevButton = document.querySelector();
})();
